export default __webpack_public_path__ + "static/media/cat-006-power-systems.74818f71.svg";